module.exports = __webpack_public_path__ + "static/media/rymindr_smiles_logo.179951fa.png";